import { useEffect, useMemo, useState } from 'react';
import { CartContext } from './CartContext';
import { DefaultCartContext, ICartContextProvider, ICartProps } from './CartContext.types';

export const CartContextProvider = (props: ICartContextProvider) => {
    const [cartProps, setCartProps] = useState(DefaultCartContext().cart);
    const [cartStepIndex, setCartStepIndex] = useState(0);
    const [isCartLoaded, setIsCartLoaded] = useState(false);

    useEffect(() => {
        reloadSession();
    }, []);

    const reloadSession = () => {
        try {
            const sessionCart = window.sessionStorage.getItem('cart');
            if (sessionCart) {
                const loadedCart = JSON.parse(sessionCart);
                setCartProps(loadedCart);
            }
        } catch (error) {
            console.error('Failed to load or parse cart from session storage', error);
        } finally {
            setIsCartLoaded(true);
        }
    };

    const updateCart = (newCart: ICartProps) => {
        window.sessionStorage.setItem('cart', JSON.stringify(newCart));
        setCartProps(newCart);
    };

    const providerValue = useMemo(() => {
        return {
            cart: cartProps,
            isCartLoaded,
            setCart: updateCart,
            reloadSession,
            cartStepIndex,
            setCartStepIndex
        };
    }, [cartProps, isCartLoaded]);

    return <CartContext.Provider value={providerValue}>{props.children}</CartContext.Provider>;
};
